export default __webpack_public_path__ + "static/Mattress-Medium-5c4f99b49339a32d3e2777e375cc1bca.gif";